import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import router from './router'
import store from './store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import Vuescroll from 'vuescroll/dist/vuescroll-native'
import 'vuescroll/dist/vuescroll.css'
Vue.use(Vuescroll)

Vue.config.productionTip = false

window.domain = "https://www.liuchengtu.com"
window.api_domain = "https://user.api.hudunsoft.com";
axios.defaults.baseURL = window.api_domain;

Vue.prototype.$http = axios;
//操作浏览器数据库
Vue.prototype.$storage = window.storage = {
    get: function (key) {
        if (window.localStorage.getItem(key.toLowerCase() + '_expires') &&
            window.localStorage.getItem(key.toLowerCase() + '_expires') < Date.parse(new Date())) {
            return null;
        }
        return JSON.parse(window.localStorage.getItem(key.toLowerCase()));
    },
    set: function (key, value, expires) {
        if (expires > 0) {
            window.localStorage.setItem(key.toLowerCase() + '_expires', Date.parse(new Date()) + (expires * 1000));
        }
        window.localStorage.setItem(key.toLowerCase(), JSON.stringify(value));
    },
    remove: function (key) {
        window.localStorage.removeItem(key.toLowerCase());
        window.localStorage.removeItem(key.toLowerCase() + '_expires');
    }

};

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

window.vue = new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')